import {
    buildConfigSliceWithGridSupport,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialOrderVolumeProfileConfiguration,
    OrderVolumeProfileConfiguration,
} from 'widgets/orderVolumeProfile/store/configuration/OrderVolumeProfileConfiguration';
import { selectOrderVolumeProfileState } from '../selectors';

export const buildOrderVolumeProfileConfigSlice = () =>
    buildConfigSliceWithGridSupport(
        WidgetType.ORDER_VOLUME_PROFILE,
        selectOrderVolumeProfileState,
        initialOrderVolumeProfileConfiguration
    );

export const useOrderVolumeProfileConfigSlice = () =>
    useConfigSlice(buildOrderVolumeProfileConfigSlice());

export type OrderVolumeProfileConfigPayloadType =
    WidgetConfigSliceActionPayloadType<OrderVolumeProfileConfiguration>;
